import axios from 'axios';

//const apiBaseUrl = 'http://localhost:3001';
const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;

const fetchData = async (url, method, data = null, headers = {}) => {
    try {
        const response = await axios({
            url: `${apiBaseUrl}/${url}`,
            method,
            data,
            headers,
        });
        return response.data;
    } catch (error) {
        console.error(`Error ${method} ${url}:`, error);
        throw error;
    }
};

const fetchTeacherById = async (teacherId) => {
    return fetchData(`api/teacher/getteacher/${teacherId}`, 'GET');
};

const fetchAllTeachers = async () => {
    try {
        const teachers = await fetchData('api/teachers/all', 'GET');
        return { teachers };
    } catch (error) {
        console.error('Error fetching all teacher information:', error);
        throw error;
    }
};

const fetchImag = async (teacherId) => {
    return fetchData(`api/teacher/image/${teacherId}`, 'GET');
};

const addTeacher = async (teacherData) => {
    const headers = {
        'Content-Type': 'multipart/form-data', 
    };
    return fetchData('api/teachers/add', 'POST', teacherData, headers);
};

const deleteTeacher = async (teacherId) => {
    return fetchData(`api/teacher/delete/${teacherId}`, 'DELETE');
};

const loginTeacher = async (username, password) => {
    return fetchData('api/login', 'POST', { username, password });
};

const updateTeacher = async (teacherId, updateTeacherInfo) => {
    return fetchData(`api/teacher/update/${teacherId}`, 'PUT', updateTeacherInfo);
};

const updateTeacherImage = async (teacherId, imageFile) => {
    const formData = new FormData();
    formData.append('image', imageFile);
    const headers = {
        'Content-Type': 'multipart/form-data',
    };
    return fetchData(`api/teacher/updateimage/${teacherId}`, 'PUT', formData, headers);
};

const changeTeacherPassword = async (teacherId, newPassword) => {
    return fetchData(`api/teacher/changepassword/${teacherId}`, 'PUT', { newPassword });
};

export {
    fetchTeacherById,
    fetchAllTeachers,
    fetchImag,
    addTeacher,
    deleteTeacher,
    loginTeacher,
    updateTeacher,
    updateTeacherImage,
    changeTeacherPassword,
};
